import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './FoundingDateScreen.module.css';
import { foundingDateSchema } from './FoundingDateScreen.schema';
import { TMobileSignupForm } from '../../form/form';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-684. Month / year the company was founded. Reads/writes the shared mobile
// signup form store (DIT-664).
export const FoundingDateScreen = () => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { validateAndContinue } = useScreenValidation(foundingDateSchema);

  return (
    <StepLayout
      stageTitle={t`Business details`}
      heading={t`When was your company founded?`}
      subHeading={t`A rough estimate is fine.`}
      onContinue={validateAndContinue}
    >
      <div className={styles.row}>
        <Input
          {...register('startDateMonth')}
          label={t`Month`}
          placeholder={t`MM`}
          inputMode="numeric"
          maxLength={2}
          error={errors.startDateMonth?.message}
        />
        <Input
          {...register('startDateYear')}
          label={t`Year`}
          placeholder={t`YYYY`}
          inputMode="numeric"
          maxLength={4}
          error={errors.startDateYear?.message}
        />
      </div>
    </StepLayout>
  );
};
